document.addEventListener("DOMContentLoaded", function(){

  const alphabetLinks = document.querySelectorAll(".alphabet-list a");


  function setActiveAlphabet(id){

    alphabetLinks.forEach(link => {

      link.classList.remove("active");

      if(link.getAttribute("href") === "#" + id){
        link.classList.add("active");
      }

    });

  }


  // Default active alphabet = A
  setActiveAlphabet("letter-A");


  // Change active alphabet only on click
  alphabetLinks.forEach(link => {

    link.addEventListener("click", function(){

      const id = this.getAttribute("href").replace("#","");

      setActiveAlphabet(id);

    });

  });


});